import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { RegraDependencia, SalvarRegraDependenciaPayload } from './regra-dependencia.model';

@Injectable({ providedIn: 'root' })
export class RegraDependenciaService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<RegraDependencia[]>> {
    return this.http.get<ApiResponse<RegraDependencia[]>>(`${this.url}/${nrSeqCupom}/dependencia`);
  }

  criar(nrSeqCupom: number, payload: SalvarRegraDependenciaPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/dependencia`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/dependencia/${nrSequencia}`);
  }
}
